const axios = require('axios')

export const state = () => ({
	indexLatestUpdated: 0,
	newProps: [],
	recommendProps: [],
	properties: [],
	getPropertyId_list: [],
	propertyId_map: [],
	favoriteList: [],
	promotionPropertyList: []
})

export const getters = {
	indexLatestUpdated: state => state.indexLatestUpdated,
	newProps: state => state.newProps,
	recommendProps: state => state.recommendProps,
	getProperty: state => (id) => {
		id = parseInt(id)
		let property = state.properties.find(p => p.id === id)
		if (typeof property === 'undefined')
			return

		return property
	},
	getPropertyId_list: state => (path) => {
		if (state.getPropertyId_list.length === 0)
			return []

		let list = state.getPropertyId_list.find(x => x.key === path)
		if (list) {
			return list
		}
		return []
	},
	properties: state => state.properties,
	favoriteList: state => state.favoriteList,
	isFavorite: state => id => state.favoriteList.indexOf(parseInt(id)) >= 0,
	promotionPropertyList: state => state.promotionPropertyList
}

export const mutations = {
	storeIndexLatestUpdated(state, data) {
		state.indexLatestUpdated = data
	},
	storeNewProps(state, data) {
		state.newProps = data
	},
	storeRecommendProps(state, data) {
		state.recommendProps = data
	},
	generateProperty(state, id) {
		let property = state.properties.find(p => p.id === id)

		let breadcrumb = [
			{
				text: 'หน้าหลัก',
				disabled: false,
				to: '/',
			},
			{
				text: property.category,
				disabled: false,
				to: '/search?market=' + property.category_en,
			},
			{
				text: this.getters.getLocation(property.province_id),
				disabled: false,
				to: '/search?province=' + property.province_id,
			},
			{
				text: this.getters.getLocationDistrict(property.province_id, property.district_id),
				disabled: false,
				to: '/search?province=' + property.province_id + '&district=' + property.district_id,
			},
			{
				text: property.property_title,
				disabled: true
			}
		]

		let spaceTotal = parseInt(property.space_1 ? property.space_1 * 400 : 0) + parseInt(property.space_2 ? property.space_2 * 100 : 0) + parseFloat(property.space_3 || 0)
		property['spaceTotal'] = spaceTotal === 0 ? '-' : spaceTotal

		property['bannerStyle'] = `background: url('${property.mainImage}'); background-size: cover;`
		property['breadcrumb'] = breadcrumb
		property['facebookShare'] = 'https://www.facebook.com/sharer/sharer.php?u=#href'
		property['generated'] = true
	},
	storeProperties(state, propertyList) {
		propertyList.forEach((property) => {
			state.properties.push(property)
		})
	},
	storeProperty(state, property) {
		let index = state.properties.findIndex(p => p.id.toString() === property.id.toString())
		property['installments'] = property.sale_price === 0 ?
			0 :
			(parseInt((((6.64/1200) * (property.sale_price * (100 - 10) / 100)) / (1 - (Math.pow(1 / (1 + (6.64/1200)), 12 * 30))) / 100) + 1) * 100)
		property['locationText'] = this.getters.getLocation(property.province_id, property.district_id, property.subdistrict_id) || '-'

		if (index === -1) {
			state.properties.push(property)
		} else {
			state.properties[index] = property
		}
	},
	storePropertyId_list(state, obj) {
		let data = {
			key: obj.path,
			value: obj.ids,
			last_page: obj.last_page,
			queryTxt: obj.queryTxt,
			total: obj.total
		}
		state.getPropertyId_list.push(data)
	},
	storePromotionPropertyId_list (state, data) {
		state.promotionPropertyList.push(...data)
	},
	addFavorite (state, id) {
		id = parseInt(id)
		if (state.favoriteList.indexOf(id) < 0) {
			state.favoriteList.push(id)
		}
	},
	removeFavorite (state, id) {
		id = parseInt(id)
		let index = state.favoriteList.indexOf(id)
		state.favoriteList.splice(index, 1)
	},
	addOrRemoveFavorite (state, id) {
		id = parseInt(id)
		let index = state.favoriteList.indexOf(id)
		if (index < 0) {
			state.favoriteList.push(id)
		} else {
			state.favoriteList.splice(index, 1)
		}
	}
}

export const actions = {
	getPropsForIndex ({ commit, getters }, callback) {
		let timeDiff = new Date() - getters.indexLatestUpdated
		// Get new data after 30 mins pass
		if (Math.round((timeDiff / 1000) / 60) > 30) {
			axios.get('https://api.tb.co.th/api/getPropsForIndex').then((res) => {
				let data = res.data

				commit('storeNewProps', data.newProps)
				commit('storeRecommendProps', data.recommendProps)
				for(let property of data.properties) {
					commit('storeProperty', property)
				}
				commit('storeIndexLatestUpdated', new Date().getTime())

				if (typeof callback === 'function') {
					callback(data)
				}
			}).catch((e) => {
				console.log(e)
			}).finally(() => {
				if (typeof callback === 'function') {
					callback()
				}
			})
		} else if (typeof callback === 'function') {
			callback()
		}
	},

	getPropertyList ({ commit, getters }, ids) {
		return new Promise((resolve, reject) => {
			let propsList = []
			let notExistList = []
			let property

			// Get property that store in state
			for (let propId of ids) {
				property = getters.getProperty(propId)
				if (property) {
					propsList.push(property)
				} else {
					notExistList.push(propId)
				}
			}

			// Get property if not exist
			if (notExistList.length > 0) {
				let idsParam = ''
				for (let propId of notExistList) {
					idsParam += `id[]=${propId}&`
				}
				axios.get(`https://api.tb.co.th/api/getPropertyList?${idsParam}`).then((res) => {
					let data = res.data

					for(property of data.propertyList) {
						commit('storeProperty', property)
						propsList.push(property)
					}
					resolve(propsList)
				}).catch(e => {
					reject(e)
				})
			} else {
				resolve(propsList)
			}
		})
	},

	getPropertyListByAgent ({ commit }, id) {
		return new Promise((resolve, reject) => {
			axios.get(`https://api.tb.co.th/api/getPropertyListByAgent?id=${id}`).then((res) => {
				let data = res.data
				data.propertyList.forEach((property) => {
					commit('storeProperty', property)
				})

				resolve(data)
			}).catch(e => {
				reject(e)
			})
		})
	},

	setPathProperties ({ commit }, path) {
		return new Promise((resolve, reject) => {
			axios.get(path).then((res) => {
				let data = res.data
				commit('storePropertyId_list', { path: data.path, ids: data.propertyList_id, total: data.propertyList.total, last_page: data.propertyList.last_page })
				data.propertyList.data.forEach((property) => {
					commit('storeProperty', property)
				})

				resolve(data.propertyList)
			}).catch(e => {
				reject(e)
			})
		})
	},

	setProperties({ commit }, properties) {
		properties.forEach(property => {
			commit('storeProperty', property)
		})
	},

	setProperty({ commit, state }, id) {
		return new Promise((resolve, reject) => {
			let property = state.properties.find(p => p.id === id)

			if (property) {
				if (typeof property.generated === 'undefined') {
					commit('generateProperty', id)
				}

				resolve(property)
			} else {
				// axios.get(`https://api.tb.co.th/api/getProperty?id=${id}`, {headers: {'Referer': 'tb.co.th'}}).then((res) => {
				axios.get(`https://api.tb.co.th/api/getProperty?id=${id}`).then((res) => {
					let data = res.data

					if (data && data.property) {
						commit('storeProperty', data.property)
						commit('generateProperty', data.property_id)

						resolve(state.properties.find(p => p.id === data.property_id))
					} else {
						resolve(null)
					}
				}).catch(e => {
					reject(e)
				})
			}
		})
	},

	searchPropertyByRadius (store, query) {
		return new Promise((resolve, reject) => {

			let path = `https://api.tb.co.th/api/getPropertyListMap${query.lat_1 ? 2 : ''}?`
			if (Object.keys(query).length > 0 && query.constructor === Object) { // Has query to search
				for(let key in query) {
					if (Array.isArray(query[key]) && query[key].length > 0) {
						for (let item of query[key]) {
							path += `${key}[]=${item}&`
						}
					} else {
						path += `${key}=${query[key]}&`
					}
				}
			}

			let queryTxt = ''
			if (query.tx) {
				if (query.tx === 'RENT')
					queryTxt += 'เช่า '
				else
					queryTxt += 'ขาย '
			}

			if (query.market) {
				if (query.market === 'REST')
					queryTxt += 'ที่อยู่อาศัย '
				else if (query.market === 'COMMERCIAL')
					queryTxt += 'ทรัพย์เชิงพาณิชย์ '
				else if (query.market === 'HOME')
					queryTxt += 'บ้าน ' // 'บ้านเดี่ยว '
				else if (query.market === 'TOWNHOUSE')
					queryTxt += 'ทาวน์เฮ้าส์ '
				else if (query.market === 'CONDO')
					queryTxt += 'คอนโด, เอื้ออาทร '
				else if (query.market === 'LAND')
					queryTxt += 'ที่ดิน '
				else if (query.market === 'COMMERCIAL_BUILDING')
					queryTxt += 'อาคารพาณิชย์ '
				else if (query.market === 'FACTORY')
					queryTxt += 'โรงงาน '
				else if (query.market === 'APARTMENT')
					queryTxt += 'อพาร์ทเม้นท์ '
				else if (query.market === 'OTHERS')
					queryTxt += 'ทรัพย์อื่นๆ '
			}

			if (query.minbeds)
				queryTxt += `${query.minbeds} ห้องนอน `

			if (query.minbath)
				queryTxt += `${query.minbath} ห้องน้ำ `

			if (query.mingarage)
				queryTxt += `${query.mingarage} ที่จอดรถ `

			if (query.province) {
				if (query.district)
					queryTxt += `ใน ${this.getters.getLocation(parseInt(query.province), parseInt(query.district))} `
				else
					queryTxt += `ใน ${this.getters.getLocation(parseInt(query.province))} `
			}

			if (query.latest) {
				if (query.latest === '3')
					queryTxt += 'ภายใน 3 วันที่ผ่านมา '
				if (query.latest === '7')
					queryTxt += 'ภายใน 1 อาทิตย์ที่ผ่านมา '
				if (query.latest === '14')
					queryTxt += 'ภายใน 2 อาทิตย์ที่ผ่านมา '
				if (query.latest === '30')
					queryTxt += 'ภายใน 1 เดือนที่ผ่านมา '
			}

			axios.get(path).then((res) => {
				let data = res.data
				resolve({
					propsList: data.propertyList,
					propsIdList: data.propertyList_id,
					queryTxt: queryTxt,
					total: data.propertyList.length
				})
			}).catch(e => {
				reject(e)
			})
		})
	},

	searchProperty ({ dispatch, getters }, query) {
		return new Promise((resolve, reject) => {

			let path = 'https://api.tb.co.th/api/getProperties'
			if (Object.keys(query).length > 0 && query.constructor === Object) { // Has query to search
				path = 'https://api.tb.co.th/api/getPropertyList' + (query.map ? 'Map?ipp=24&' : '?ipp=24&')
				for(let key in query) {
					if (Array.isArray(query[key]) && query[key].length > 0) {
						for (let item of query[key]) {
							path += `${key}[]=${item}&`
						}
					} else {
						path += `${key}=${query[key]}&`
					}
				}
			}

			let propObj = getters.getPropertyId_list(path)
			if(propObj.length > 0) {
				dispatch('getPropertyList', propObj.propIds).then(propsList => {
					resolve({
						propsList: propsList,
						queryTxt: propObj.queryTxt,
						total: propObj.total
					})
				}).catch(error => {
					reject(error)
				})
			} else {
				let queryTxt = ''
				if (query.tx) {
					if (query.tx === 'RENT')
						queryTxt += 'เช่า '
					else
						queryTxt += 'ขาย '
				}

				if (query.market) {
					if (query.market === 'REST')
						queryTxt += 'ที่อยู่อาศัย '
					else if (query.market === 'COMMERCIAL')
						queryTxt += 'ทรัพย์เชิงพาณิชย์ '
					else if (query.market === 'HOME')
						queryTxt += 'บ้าน ' // 'บ้านเดี่ยว '
					else if (query.market === 'TOWNHOUSE')
						queryTxt += 'ทาวน์เฮ้าส์ '
					else if (query.market === 'CONDO')
						queryTxt += 'คอนโด เอื้ออาทร '
					else if (query.market === 'LAND')
						queryTxt += 'ที่ดิน '
					else if (query.market === 'COMMERCIAL_BUILDING')
						queryTxt += 'อาคารพาณิชย์ '
					else if (query.market === 'FACTORY')
						queryTxt += 'โรงงาน '
					else if (query.market === 'APARTMENT')
						queryTxt += 'อพาร์ทเม้นท์ '
					else if (query.market === 'OTHERS')
						queryTxt += 'ทรัพย์อื่นๆ '
				}

				const market_selected = typeof query.market_selected === 'string' ? [query.market_selected] : query.market_selected
				if (query.market_selected) {
					for (const i in market_selected) {
						if (i > 0) queryTxt += ', '
						if (market_selected[i] === 'HOME')
							queryTxt += 'บ้าน ' // 'บ้านเดี่ยว'
						else if (market_selected[i] === 'TOWNHOUSE')
							queryTxt += 'ทาวน์เฮ้าส์'
						else if (market_selected[i] === 'CONDO')
							queryTxt += 'คอนโด, เอื้ออาทร'
						else if (market_selected[i] === 'LAND')
							queryTxt += 'ที่ดิน'
						else if (market_selected[i] === 'COMMERCIAL_BUILDING')
							queryTxt += 'อาคารพาณิชย์'
						else if (market_selected[i] === 'FACTORY')
							queryTxt += 'โรงงาน'
						else if (market_selected[i] === 'APARTMENT')
							queryTxt += 'อพาร์ทเม้นท์'
						else if (market_selected[i] === 'OTHERS')
							queryTxt += 'ทรัพย์อื่นๆ'
					}
					queryTxt += ' '
				}

				if (query.minbeds)
					queryTxt += `${query.minbeds} ห้องนอน `

				if (query.minbath)
					queryTxt += `${query.minbath} ห้องน้ำ `

				if (query.mingarage)
					queryTxt += `${query.mingarage} ที่จอดรถ `

				if (query.province) {
					if (query.district)
						queryTxt += `ใน ${this.getters.getLocation(parseInt(query.province), parseInt(query.district))} `
					else
						queryTxt += `ใน ${this.getters.getLocation(parseInt(query.province))} `
				}

				if (query.latest) {
					if (query.latest === '3')
						queryTxt += 'ภายใน 3 วันที่ผ่านมา '
					if (query.latest === '7')
						queryTxt += 'ภายใน 1 อาทิตย์ที่ผ่านมา '
					if (query.latest === '14')
						queryTxt += 'ภายใน 2 อาทิตย์ที่ผ่านมา '
					if (query.latest === '30')
						queryTxt += 'ภายใน 1 เดือนที่ผ่านมา '
				}

				dispatch('setPathProperties', path).then(propObj => {
					resolve({
						propsList: propObj.data,
						queryTxt: queryTxt,
						total: propObj.total,
						perPage: propObj.per_page
					})
				}).catch(error => {
					reject(error)
				})
			}
		})
	},

	getPromotionProperty ({ commit, dispatch }/*, page*/) {
		return new Promise((resolve, reject) => {
			// let path = 'https://api.tb.co.th/api/getPropertyList?promotion=static' + (page ? `&page=${page}` : '')
			// dispatch('setPathProperties', path).then(propObj => {
			// 	commit('storePromotionPropertyId_list', propObj.data.map(item => item.id))
			// 	if (propObj.current_page < Math.min(3, propObj.last_page || 0)) {
			// 		dispatch('getPromotionProperty', propObj.current_page + 1)
			// 	}
			// 	resolve()
			// }).catch(error => {
			// 	reject(error)
			// })
			let path = 'https://api.tb.co.th/api/getPropertyPromotion?promotion=static&random=18&r=' + Math.random()
			dispatch('setPathProperties', path).then(propObj => {
				commit('storePromotionPropertyId_list', propObj.data.map(item => item.id))
				resolve()
			}).catch(error => {
				reject(error)
			})
		})
	},

	/* eslint-disable no-unused-vars */
	customerInquiry ({ commit }, data) {
		return new Promise((resolve, reject) => {
			let path = 'https://api.tb.co.th/api/interestProperty?'
			for(let key in data) {
				path += `${key}=${data[key]}&`
			}
			axios.get(path).then((res) => {
				resolve(res.data)
			}).catch(e => {
				reject(e)
			})
		})
	},

	locationQuery ({ commit }, text) {
		return new Promise((resolve, reject) => {
			let path = `https://api.tb.co.th/api/search-text?text=${text}`
			axios.get(path).then((res) => {
				let data = res.data

				resolve(data.lists)
			}).catch(e => {
				reject(e)
			})
		})
	},
	/* eslint-enable no-unused-vars */

	setPropertyId_list({ commit }, obj) {
		commit('storePropertyId_list', obj)
	},

	addFavorite ({ commit }, id) {
		commit('addFavorite', id)
	},

	removeFavorite ({ commit }, id) {
		commit('removeFavorite', id)
	},

	addOrRemoveFavorite ({ commit }, id) {
		commit('addOrRemoveFavorite', id)
	}
}
